/**
 * summary: Module to toggle elements in the dom when the displayed element is clicked
 * the event will be added to the document to set an event delegation
 * 
 * Example hidden elements:
        data-listing-MyElement

 * Example displayed element:
        data-toggle-element="[data-listing-MyElement]"
 *
 * Make sure to add some value to the hidden elements to show
 */
(function elementToggler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.ElementToggler = global.NewHomeSource.ElementToggler || {};
  const previousElementTogglerModule = global.NewHomeSource.ElementToggler;

  /**
  * @constructs ElementToggler
  */
  function ElementToggler() {
  }

  /**
  * @public
  * SwitchElements: function to turn off the target element and turn on a hidden element
  * @param {HTMLElement} target DOM Element
  */
  function ToggleElements(target) {
    const elementsToShow = target && target.dataset.toggleElement
      ? document.querySelectorAll(target.dataset.toggleElement)
      : null;

    if (elementsToShow && elementsToShow.length > 0) {
      for (let i = 0; i < elementsToShow.length; i += 1) {
        elementsToShow[i].removeAttribute('hidden');
        const callForDetailSelector = `[data-toggle-element="${target.dataset.toggleElement}"]`;
        const callForDetailsButton = elementsToShow[i].parentElement.querySelector(callForDetailSelector);
        callForDetailsButton.setAttribute('hidden', '');
      }
    }
  }

  /**
  * @public
  * SwitchButtonByText: set the listener to the event on the document element
  */
  ElementToggler.Init = function Init() {
    document.addEventListener('click', (e) => {
      ToggleElements(e.target);
    });
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.ElementToggler to the previous script.
   */
  ElementToggler.noConflict = function noConflict() {
    global.NewHomeSource.ElementSwitcher = previousElementTogglerModule;
    return ElementToggler;
  };

  global.NewHomeSource.ElementToggler = ElementToggler;

  return ElementToggler;

}(window));
